module.exports = {
  IDMClientTokenKey: "a455c24f-a060-491a-9cc4-b4ca9ca1fbb5",
  IDMClientTokenSecret: "c5e66687-a7b9-4439-b04b-56bfb0dc7716",
  IDMClientOptions: {
    externalAuth: false,
    externalAuthDomain: "https://files4ever.com/a",
    externalAuthPath: "/login",
    externalValidatePath: "/validate",
    externalRegistrationPath: "/register",
    cookiesEndpoint: "https://files4ever.com/a",
    apiEndpoint: "https://api-auth.files4ever.com",
    roles: {
      USER: "72ae4edf-99b_OrangePiggy",
      SYSADMIN: "afbfb035-434_OrangePiggy",
      BILLINGADMIN: "bc533d33-e3e_OrangePiggy",
      HELPDESK: "46a59f42-26b_OrangePiggy"
    },
    partitions: {}
  },
  ApplicationName: "Files4Ever",
  ApplicationDomain: "files4ever.com",
  ApplicationAuthDomain: "files4ever.com",
  AccountAppSubdomain: "myaccount",
  IntegrationsDesktopSubdomain: "desktop",
  IntegrationsMobileSubdomain: "mobile",
  ApplicationAPIEndpoint: "https://api.files4ever.com",
  ApplicationThemeEndpoint: "https://dvjzrgjc61ad1.cloudfront.net",
  ApplicationGoogleAnalyticsKey: "UA-214095959-1",
  ApplicationRoutes: {
    login: "/",
    homepage: "/",
    settings: "/settings",
    profile: "/profile",
    vaults: "/vaults",
    dockets: "/dockets",
    adminUserInvitation: "/user-invitation"
  },
  DatadogOptions: {
    applicationId: "31fa36fd-7a17-48b5-9509-a99d0f12df3a",
    clientToken: "pub2f9e05cf1d0f9f127c03c968b2d3d20f",
    site: "datadoghq.com",
    service: "orangepiggy-fe",
    env: "development",
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: "allow"
  },
  Slaask: {
    enabled: false,
    widgetKey: "spk-46e4fb9a-d23b-4ea2-a388-238c6cdb1f79",
    secretKey: "ssk-secret-86dd8afb-3143-4ebf-a507-81631fb462be"
  }
}